//functions here are intended to be used as replacements for the functions provided by lodash as it has known security vulnerabilities

//replaces lodash _.get https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore#_get
export const getPropertyValue = (obj, path, defaultValue = undefined) => {
	const travel = regexp =>
		String.prototype.split
			.call(path, regexp)
			.filter(Boolean)
			.reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj);
	const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/);
	return result === undefined || result === obj ? defaultValue : result;
};

//replaces lodash _.set (taken from GitHub Copilot response, so take with a lump of salt whether it works right)
//raw copilot code couldn't handle it if current[path[path.length -1]] was a null object
export const setPropertyValue = (obj, path, value) => {
	if (typeof path === 'string') {
		path = path.replace(/\[(\w+)\]/g, '.$1').replace(/^\./, '').split('.');
	}
	let current = obj;
	for (let i = 0; i < path.length - 1; i++) {
		//Treat null the same as undefined here - typeof null === 'object', so without this check a null
		//intermediate value (e.g. an unset nested object property serialized from the API as null) would
		//be treated as "already exists", current would be set to null, and the write below would then be
		//silently skipped by the final current != null guard.
		if (current[path[i]] == null || typeof current[path[i]] !== 'object') {
			// Create object or array if next key is a number
			current[path[i]] = /^\d+$/.test(path[i + 1]) ? [] : {};
		}
		current = current[path[i]];
	}
	if (current != null) {
		current[path[path.length - 1]] = value;
	}
	return obj;
}

//replaces lodash_.isEqual
//taken from https://medium.com/javascript-in-plain-english/you-dont-need-lodash-how-i-gave-up-lodash-693c8b96a07c (member-only article)
export function isEqual(x, y) {
	console.log('isEqual invoked');
	const ok = Object.keys, tx = typeof x, ty = typeof y;
	return x && y && tx === 'object' && tx === ty ? (
		ok(x).length === ok(y).length &&
		ok(x).every(key => isEqual(x[key], y[key]))
	) : (x === y);
}

//replaces lodash _.isEmpty, taken from a GitHub Copilot response, so it definitely needs testing
//there is a 'You-Dont-Need-Lodash-Underscore option, but it says it doesn't cover Sets and Maps, which the Copilot response seems to account for
export function isEmpty(value) {
	if (value == null) return true; // null or undefined
	if (typeof value === 'string' || Array.isArray(value)) return value.length === 0;
	if (value instanceof Map || value instanceof Set) return value.size === 0;
	if (typeof value === 'object') return Object.keys(value).length === 0;
	return false;
}

//replaces lodash _.mapKeys
//https://github.com/you-dont-need/You-Dont-Need-Lodash-Underscore?tab=readme-ov-file#_mapKeys
export const mapKeys = (object, cb) => Object.entries(object)
	.reduce((acc, current) => {
		const newKey = cb(current[1], current[0], object);
		acc[newKey] = current[1];
		return acc;
	}, {}
);

//replcae lodash _.omit
// based on a copilot response, as the example on You-Dont-Need-Lodash-Underscore wasn't in a state that could be easily extrapolated into a function
export function omit(obj: any, path: string): any {
	const keys = path.split('.');
	if (keys.length === 0) return { ...obj };

	const [first, ...rest] = keys;

	if (!(obj && typeof obj === 'object' && first in obj)) {
		return Array.isArray(obj) ? [...obj] : { ...obj };
	}

	if (rest.length === 0) {
		if (Array.isArray(obj)) {
			const copy = [...obj];
			copy.splice(Number(first), 1);
			return copy;
		} else {
			const { [first]: _, ...result } = obj;
			return result;
		}
	}

	return {
		...obj,
		[first]: omit(obj[first], rest.join('.'))
	};
}
